import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SkeletonLoader from './components/SkeletonLoader';
import ScrollToTopBtn from "./components/ScrollToTopBtn";
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";
import WhatsAppButton from "./components/WhatsAppButton";
import ServiceDynamicPage from "./pages/services/ServiceDynamicPage";

// Legal Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

// Main Pages
const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const Industries = lazy(() => import('./pages/Industries'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));

// Industry Pages
const Healthcare = lazy(() => import('./pages/industries/Healthcare'));
const Technology = lazy(() => import('./pages/industries/Technology'));
const BankingFinance = lazy(() => import('./pages/industries/BankingFinance'));
const Manufacturing = lazy(() => import('./pages/industries/Manufacturing'));
const TravelHospitality = lazy(() => import('./pages/industries/TravelHospitality'));
const EducationEdTech = lazy(() => import('./pages/industries/EducationEdTech'));
const RetailEcommerce = lazy(() => import('./pages/industries/RetailEcommerce'));
const SecurityServices = lazy(() => import('./pages/industries/SecurityServices'));
const RealEstate = lazy(() => import('./pages/industries/RealEstate'));
const HrRecruitment = lazy(() => import('./pages/industries/HrRecruitment'));


export default function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />

      <div className="min-h-screen font-poppins text-gray-800 flex flex-col">
        <Navbar />

        <Suspense fallback={<SkeletonLoader />}>
          <Routes>

            {/* MAIN ROUTES */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* INDUSTRY ROUTES */}
<Route path="/industries/healthcare" element={<Healthcare />} />
<Route path="/industries/technology" element={<Technology />} />
<Route path="/industries/banking-finance" element={<BankingFinance />} />
<Route path="/industries/manufacturing" element={<Manufacturing />} />
<Route path="/industries/travel-hospitality" element={<TravelHospitality />} />
<Route path="/industries/education-edtech" element={<EducationEdTech />} />
<Route path="/industries/retail-ecommerce" element={<RetailEcommerce />} />
<Route path="/industries/security-services" element={<SecurityServices />} />
<Route path="/industries/real-estate" element={<RealEstate />} />
<Route path="/industries/hr-recruitment" element={<HrRecruitment />} />


            {/* LEGAL PAGES */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />

            <Route path="/services/:slug" element={<ServiceDynamicPage />} />


          </Routes>
        </Suspense>

        <Footer />
        {/* <WhatsAppButton /> */}
        <ScrollToTopBtn />
      </div>
    </Router>
  );
}
